import React from "react";

const VARIANT_STYLES = {
    blue: "border-indigo-100 bg-indigo-50 text-indigo-700",
    green: "border-emerald-100 bg-emerald-50 text-emerald-700",
    amber: "border-amber-100 bg-amber-50 text-amber-700",
    red: "border-red-100 bg-red-50 text-red-700",
    gray: "border-slate-100 bg-slate-50 text-slate-700",
};

const CampaignStatCard = ({
    label,
    value,
    icon: Icon,
    variant = "blue",
}) => {
    const accentClass = VARIANT_STYLES[variant] || VARIANT_STYLES.blue;

    return (
        <div className="min-w-0 rounded-2xl border border-slate-200 bg-white p-3 shadow-sm sm:p-4">
            <div className="flex items-center gap-2.5 sm:gap-3">
                {Icon && (
                    <div
                        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${accentClass}`}
                    >
                        <Icon size={20} aria-hidden="true" />
                    </div>
                )}

                <div className="min-w-0">
                    <p className="text-xs font-semibold text-slate-500 sm:text-sm">
                        {label || "Metric"}
                    </p>
                    <p className="mt-1 truncate text-xl font-bold text-slate-900 sm:text-2xl">
                        {value ?? 0}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CampaignStatCard;
